import Icon from "~/components/ui/Icon"
import VariantLink from "~/components/product/VariantSelector/VariantLink"

interface Props {
    url?: string
}

export default function NoStockButton({ url }: Props) {
    return (
        <VariantLink
            url={url}
            className='grid w-full h-[76px] text-xs border text-center border-neutral-300 overflow-hidden'
        >
            <p className='bg-neutral-200 px-1 py-0.5'>ESGOTADO</p>
            <span className='text-[10px] leading-none'>
                <Icon id='PDPEmail' className='text-salmon mx-auto' size={14} />
                Avise-me quando chegar
            </span>
        </VariantLink>
    )
}
